import React from 'react';
import Select from 'react-select';
import customStylesSelect from '@styles/react-select';

const SelectOptionComp = React.forwardRef(({
  label,
  name,
  options,
  value,
  onChange,
  placeholder,
  hoverMessage,
  required,
  isClearable,
  isDisabled,
  isSearchable,
  className,
  error,
  isLoading,
  hidden,
  ...rest
}, ref) => {
  return (
    <div
      className={`row mb-1 ${hidden ? 'd-none' : ''}`}
      title={hoverMessage}
    >
      <label htmlFor={name} className="col-auto col-form-label">
        {label}
      </label>
      <div className="col-auto">
        <Select
          ref={ref}
          value={value}
          onChange={onChange}
          options={options}
          styles={customStylesSelect}
          placeholder={placeholder}
          isClearable={isClearable}
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          className={className}
          {...rest}
          required={required}
          isLoading={isLoading}
          loadingMessage={() => "Carregando..."}
          noOptionsMessage={() => "Nenhuma opção disponível"}
        />
      </div>
      {error && <p className="text-danger mt-2">{error.message}</p>}
    </div>
  );
});


export default SelectOptionComp;